import { AdminList, AdminDataGrid, GridColumn } from './shared';
/**
 * Category List Component
 * Displays list of card categories with card counts
 */

import {
  TextField,
  DateField,
  SearchInput,
  useRecordContext,
} from 'react-admin';
import { Chip, Typography } from '@mui/material';
import { brand, semantic } from '@rekindle/shared/theme';
import { ListActions } from './shared';

/**
 * Custom field to display card count with badge
 */
function CardCountField() {
  const record = useRecordContext();
  const count = record?.cardCount ?? 0;

  return (
    <Chip
      label={`${count} cards`}
      size="small"
      sx={{
        backgroundColor: count > 0 ? brand.primary : semantic.neutral,
        color: 'white',
      }}
    />
  );
}

/**
 * Custom field for description with truncation
 */
function DescriptionField() {
  const record = useRecordContext();
  if (!record?.description) {
    return <Typography variant="body2" color="textSecondary">No description</Typography>;
  }

  const truncated = record.description.length > 60
    ? record.description.substring(0, 60) + '...'
    : record.description;

  return (
    <Typography variant="body2" title={record.description}>
      {truncated}
    </Typography>
  );
}

/**
 * Filters for category list
 */
const categoryFilters = [
  <SearchInput key="q" source="q" alwaysOn placeholder="Search categories..." />,
];

export function CategoryList() {
  return (
    <AdminList
      filters={categoryFilters}
      actions={<ListActions />}
      sort={{ field: 'createdAt', order: 'DESC' }}
      perPage={25}
    >
      <AdminDataGrid bulkActionButtons={false} rowClick="edit" omit={['id']}>
        <TextField source="id" label="ID" />
        <TextField source="name" label="Name" />
        <GridColumn label="Description" source="description"><DescriptionField /></GridColumn>
        <GridColumn label="Cards" source="cardCount"><CardCountField /></GridColumn>
        <DateField source="createdAt" label="Created" showTime />
      </AdminDataGrid>
    </AdminList>
  );
}
